import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CatalogFacade } from '@catalog/data-access/v2';
import { Store } from '@ngrx/store';
import { OccFacetsService } from '@search/data-access';
import { StateWithSeo } from '@seo/data-access';
import { CustomPageMeta } from '@shared/models';
import { ActivatedRoutesService } from '@spartacus/core';
import { combineLatest, filter, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SeoPageService } from './seo-page.service';

@Injectable({
  providedIn: 'root',
})
export class SeoCatalogPageService extends SeoPageService {
  private categoryNavCode$ = this.activatedRoutesService.routes$.pipe(
    filter<ActivatedRouteSnapshot[]>(Boolean),
    map((routes) => routes[routes.length - 1].paramMap.get('categoryCode')),
  );

  private categoryNode$ = this.categoryNavCode$.pipe(switchMap((node) => this.catalogFacade.getNode(node)));

  private breadcrumbs$ = this.categoryNode$.pipe(
    switchMap((node) => {
      if (node && node.entry) {
        return this.facetService.loadCategoryCode(node?.entry.categoryCode);
      } else return of({ breadcrumbs: [] });
    }),
    map((data) => data?.breadcrumbs || []),
  );

  constructor(
    store: Store<StateWithSeo>,
    private activatedRoutesService: ActivatedRoutesService,
    private facetService: OccFacetsService,
    private catalogFacade: CatalogFacade,
  ) {
    super(store);
  }

  getSeoPage(): Observable<CustomPageMeta | null> {
    return combineLatest({
      breadcrumbs: this.breadcrumbs$,
      seoData: super.getSeoPage(),
    }).pipe(
      map(({ breadcrumbs, seoData }) => {
        const formattedBreadcrumbs =
          breadcrumbs?.map((breadcrumb) => ({
            label: breadcrumb.facetValueName as string,
            link: `/category/${breadcrumb.facetValueCode}`,
          })) || [];

        if (seoData?.breadcrumbs) {
          seoData.breadcrumbs = [
            { label: 'главная', link: '/' },
            { label: 'каталог', link: '/catalog' },
            ...formattedBreadcrumbs,
          ];
        }

        return seoData;
      }),
    );
  }
}
